import CardsActionTypes from './cards-types'

const INITIAL_STATE = {
    loader: null,
    success: null,
    successData: null,
    cardDetails: null,
    cardPrograms: null,
    cardShipping: null,
    cardPin: false,
    cardFreezeId: null,
    error: null,
}

const cardsReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CardsActionTypes.START_GET_CARD:
            return {
                ...state,
                loader: { ...state.loader, GET_CARD: true },
            }
        case CardsActionTypes.SUCCESS_GET_CARD:
            return {
                ...state,
                loader: { ...state.loader, GET_CARD: null },
                card: action.payload,
            }
        case CardsActionTypes.GET_CARD_PROGRAMS:
            return {
                ...state,
                loader: { ...state.loader, CARD_PROGRAMS: true },
            }
        case CardsActionTypes.SUCCESS_CARD_PROGRAMS:
            return {
                ...state,
                loader: { ...state.loader, CARD_PROGRAMS: null },
                cardPrograms: action.payload,
            }

        case CardsActionTypes.GET_CARD_SHIPPING:
            return {
                ...state,
                loader: { ...state.loader, CARD_SHIPPING: true },
            }
        case CardsActionTypes.SUCCESS_CARD_SHIPPING:
            return {
                ...state,
                loader: { ...state.loader, CARD_SHIPPING: null },
                cardShipping: action.payload,
            }

        case CardsActionTypes.START_CARD_ORDER:
            return {
                ...state,
                loader: { ...state.loader, CARD_ORDER: true },
            }
        case CardsActionTypes.SUCCESS_CARD_ORDER:
            return {
                ...state,
                success: { ...state.success, CARD_ORDER: true },
                loader: { ...state.loader, CARD_ORDER: null },
                error: null,
            }
        case CardsActionTypes.FINISH_CARD_ORDER:
            return {
                ...state,
                success: { ...state.success, CARD_ORDER: null },
                loader: { ...state.loader, CARD_ORDER: null },
                cardPrograms: null,
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_ORDER:
            return {
                ...state,
                success: { ...state.success, CARD_ORDER: null },
                loader: { ...state.loader, CARD_ORDER: null },
                error: true,
            }

        case CardsActionTypes.START_CARD_TOP_UP:
            return {
                ...state,
                loader: { ...state.loader, CARD_TOP_UP: true },
            }
        case CardsActionTypes.SUCCESS_CARD_TOP_UP:
            return {
                ...state,
                success: { ...state.success, CARD_TOP_UP: true },
                loader: { ...state.loader, CARD_TOP_UP: null },
                successData: action.payload,
                error: null,
            }
        case CardsActionTypes.FINISH_CARD_TOP_UP:
            return {
                ...state,
                success: { ...state.success, CARD_TOP_UP: null },
                loader: { ...state.loader, CARD_TOP_UP: null },
                successData: null,
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_TOP_UP:
            return {
                ...state,
                success: { ...state.success, CARD_TOP_UP: null },
                loader: { ...state.loader, CARD_TOP_UP: null },
                successData: null,
                error: true,
            }

        case CardsActionTypes.START_CARD_WITHDRAW:
            return {
                ...state,
                loader: { ...state.loader, CARD_WITHDRAW: true },
            }
        case CardsActionTypes.SUCCESS_CARD_WITHDRAW:
            return {
                ...state,
                success: { ...state.success, CARD_WITHDRAW: true },
                loader: { ...state.loader, CARD_WITHDRAW: null },
                successData: action.payload?.successData || null,
                error: null,
            }
        case CardsActionTypes.FINISH_CARD_WITHDRAW:
            return {
                ...state,
                success: { ...state.success, CARD_WITHDRAW: null },
                loader: { ...state.loader, CARD_WITHDRAW: null },
                successData: null,
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_WITHDRAW:
            return {
                ...state,
                loader: { ...state.loader, CARD_WITHDRAW: null },
                success: { ...state.success, CARD_WITHDRAW: null },
                successData: null,
                error: true,
            }

        case CardsActionTypes.START_CARD_FREEZE:
            return {
                ...state,
                loader: { ...state.loader, CARD_FREEZE: true },
                cardFreezeId: action.payload.identifier,
            }
        case CardsActionTypes.SUCCESS_CARD_FREEZE:
            return {
                ...state,
                success: { ...state.success, CARD_FREEZE: true },
                loader: { ...state.loader, CARD_FREEZE: null },
                cardDetails: null,
                cardFreezeId: null,
                error: null,
            }
        case CardsActionTypes.FINISH_CARD_FREEZE:
            return {
                ...state,
                success: { ...state.success, CARD_FREEZE: null },
                loader: { ...state.loader, CARD_FREEZE: null },
                cardFreezeId: null,
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_FREEZE:
            return {
                ...state,
                success: { ...state.success, CARD_FREEZE: null },
                loader: { ...state.loader, CARD_FREEZE: null },
                cardFreezeId: null,
                error: true,
            }

        case CardsActionTypes.START_CARD_UNFREEZE:
            return {
                ...state,
                loader: { ...state.loader, CARD_UNFREEZE: true },
                cardFreezeId: action.payload.identifier,
            }
        case CardsActionTypes.SUCCESS_CARD_UNFREEZE:
            return {
                ...state,
                success: { ...state.success, CARD_UNFREEZE: true },
                loader: { ...state.loader, CARD_UNFREEZE: null },
                cardDetails: null,
                cardFreezeId: null,
                error: null,
            }
        case CardsActionTypes.FINISH_CARD_UNFREEZE:
            return {
                ...state,
                success: { ...state.success, CARD_UNFREEZE: null },
                loader: { ...state.loader, CARD_UNFREEZE: null },
                cardFreezeId: null,
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_UNFREEZE:
            return {
                ...state,
                success: { ...state.success, CARD_UNFREEZE: null },
                loader: { ...state.loader, CARD_UNFREEZE: null },
                cardFreezeId: null,
                error: true,
            }

        case CardsActionTypes.START_CARD_ACTIVATION:
            return {
                ...state,
                loader: { ...state.loader, CARD_ACTIVATION: true },
            }
        case CardsActionTypes.SUCCESS_CARD_ACTIVATION:
            return {
                ...state,
                successData: action.payload?.successData || null,
                loader: { ...state.loader, CARD_ACTIVATION: null },
                success: { ...state.success, CARD_ACTIVATION: true },
                error: null,
            }
        case CardsActionTypes.FINISH_CARD_ACTIVATION:
            return {
                ...state,
                successData: null,
                loader: { ...state.loader, CARD_ACTIVATION: null },
                success: { ...state.success, CARD_ACTIVATION: null },
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_ACTIVATION:
            return {
                ...state,
                successData: null,
                loader: { ...state.loader, CARD_ACTIVATION: null },
                success: { ...state.success, CARD_ACTIVATION: null },
                error: true,
            }

        case CardsActionTypes.START_CARD_DEACTIVATE:
            return {
                ...state,
                loader: { ...state.loader, CARD_DEACTIVATE: true },
            }
        case CardsActionTypes.SUCCESS_CARD_DEACTIVATE:
            return {
                ...state,
                success: { ...state.success, CARD_DEACTIVATE: true },
                loader: { ...state.loader, CARD_DEACTIVATE: null },
                error: null,
            }

        case CardsActionTypes.FINISH_CARD_DEACTIVATE:
            return {
                ...state,
                success: { ...state.success, CARD_DEACTIVATE: null },
                loader: { ...state.loader, CARD_DEACTIVATE: null },
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_DEACTIVATE:
            return {
                ...state,
                success: { ...state.success, CARD_DEACTIVATE: null },
                loader: { ...state.loader, CARD_DEACTIVATE: null },
                error: true,
            }

        case CardsActionTypes.START_CARD_DETAILS:
            return {
                ...state,
                loader: { ...state.loader, CARD_DETAILS: true },
            }
        case CardsActionTypes.SUCCESS_CARD_DETAILS:
            return {
                ...state,
                cardDetails: action.payload,
                loader: { ...state.loader, CARD_DETAILS: null },
                success: { ...state.success, CARD_DETAILS: true },
                error: null,
            }
        case CardsActionTypes.FINISH_CARD_DETAILS:
            return {
                ...state,
                cardDetails: null,
                loader: { ...state.loader, CARD_DETAILS: null },
                success: { ...state.success, CARD_DETAILS: null },
                error: null,
            }
        case CardsActionTypes.FAILURE_CARD_DETAILS:
            return {
                ...state,
                cardDetails: null,
                loader: { ...state.loader, CARD_DETAILS: null },
                success: { ...state.success, CARD_DETAILS: null },
                error: true,
            }

        case CardsActionTypes.START_RECEIVE_PIN:
            return {
                ...state,
                loader: { ...state.loader, RECEIVE_PIN: true },
            }
        case CardsActionTypes.SUCCESS_RECEIVE_PIN:
            return {
                ...state,
                cardPin: action.payload,
                loader: { ...state.loader, RECEIVE_PIN: null },
                success: { ...state.success, RECEIVE_PIN: true },
                error: null,
            }
        case CardsActionTypes.FINISH_RECEIVE_PIN:
            return {
                ...state,
                cardPin: null,
                loader: { ...state.loader, RECEIVE_PIN: null },
                success: { ...state.success, RECEIVE_PIN: null },
                error: null,
            }
        case CardsActionTypes.FAILURE_RECEIVE_PIN:
            return {
                ...state,
                cardPin: null,
                loader: { ...state.loader, RECEIVE_PIN: null },
                success: { ...state.success, RECEIVE_PIN: null },
                error: true,
            }

        default:
            return state
    }
}

export default cardsReducer
